import { Header } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { Avatar, Dropdown, Menu, MenuProps, Badge, Button } from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import { AuthContext } from "../../../config/AuthContext";
import { CheckOutlined, HomeMax, LogoutOutlined, Person } from "@mui/icons-material";
import { BsBackpack, BsDatabase, BsPerson, BsChatDots, BsBook, BsBell, BsLightbulb, BsCodeSquare } from "react-icons/bs";
import { RiJavascriptFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import JutgeColors from "../../../styles/JutgeColors";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import GlobalChatNotification from "../../components/GlobalChatNotification";
import ChatTableModal from "./ChatTableModal";
import SugerimentsModal from "../../components/SugerimentsModal";
import AdminSugerimentsModal from "../../components/AdminSugerimentsModal";
import { CountUnreadSugeriments } from "../../../dao/jutge/CountUnreadSugeriments";
import { GetAlumneId } from "../../../dao/GetAlumneId";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";
import UserProfileMenu from "../../components/UserProfileMenu";
import HomeColors from "../../../styles/HomeColors";

const AppHeader = () => {
    const { isLoggedIn, userPermisos, alumne, user, userId, setAlumneInfo } = useContext(AuthContext);
    const titles: string[] = ['Home', 'Base de Dades', 'Jutge Online', 'Projectes', 'Metadata'];
    const paths: string[] = ['/home', '/database', '/jutge', '/abp', '/metadata'];
    const icons: any[] = [HomeMax, BsDatabase, RiJavascriptFill, CheckOutlined, BsCodeSquare];

    const [historyVisible, setHistoryVisible] = useState(false);
    const [sugerimentsVisible, setSugerimentsVisible] = useState(false);
    const [adminSugerimentsVisible, setAdminSugerimentsVisible] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const isAdmin = user?.tipus === "1" || user?.tipus === "0";
    const isImpersonating = !!localStorage.getItem('adminToken');

    const handleStopImpersonation = () => {
        const adminToken = localStorage.getItem('adminToken');
        if (adminToken) {
            localStorage.setItem('authToken', adminToken);
            localStorage.setItem('userId', localStorage.getItem('admin_userId') || '');
            localStorage.setItem('user', localStorage.getItem('admin_user') || '');
            localStorage.setItem('userPermisos', localStorage.getItem('admin_userPermisos') || '');
            localStorage.setItem('alumneInfo', localStorage.getItem('admin_alumneInfo') || '');

            localStorage.removeItem('adminToken');
            localStorage.removeItem('admin_userId');
            localStorage.removeItem('admin_user');
            localStorage.removeItem('admin_userPermisos');
            localStorage.removeItem('admin_alumneInfo');

            window.location.reload();
        }
    };

    useEffect(() => {
        if (isAdmin) fetchCount();
    }, [isAdmin]);

    const fetchCount = useCallback(async () => {
        const c = await CountUnreadSugeriments();
        setUnreadCount(c);
    }, []);

    const onWebSocketMessage = useCallback(() => {
        if (isAdmin) fetchCount();
    }, [isAdmin, fetchCount]);

    UseWebSocketSubscription(['/topic/sugerencias'], onWebSocketMessage);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [isLoggedIn, userId]);

    const checkDades = async () => {
        if (userId && (!alumne || !alumne.alumne || alumne.alumne.id === 0 || !alumne.alumne.avatar)) {
            try {
                const res = await GetAlumneId(userId);
                if (res) {
                    setAlumneInfo(res);
                }
            } catch (error) {
                console.error("Error fetching alumne data:", error);
            }
        }
    };

    const navigate = useNavigate();

    type MenuItem = Required<MenuProps>['items'][number];

    const items1: MenuItem[] = icons.map((icon, index) => {
        const key = String(index + 1);

        // Comprueba si el usuario tiene permiso
        const hasPermission = userPermisos.some((valor: any) => valor.accio === paths[index]);

        // Si no tiene permiso, retorna null
        if (!hasPermission) {
            return null;
        }

        // Si tiene permiso, retorna el item del menú
        return {
            key: key,
            icon: React.createElement(icon),
            label: titles[index],
            onClick: () => navigate(paths[index]),
        };
    }).filter(Boolean); // Filtra elementos nulos o indefinidos

    const hasJutgePermission = userPermisos.some((valor: any) => valor.accio === '/jutge');
    const onClick: MenuProps['onClick'] = (e) => {
        const pathIndex = parseInt(e.key) - 1;
        console.log(pathIndex);
        //navigate(paths[pathIndex]);
    };

    const isRole3 = String(user?.tipus) === "3";

    if (isLoggedIn) {
        return (
            <Header style={{ display: 'flex', alignItems: 'center', backgroundColor: JutgeColors.colors.color6, position: 'sticky', top: 0, zIndex: 1000, width: '100%' }}>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                    {!isRole3 && (
                        <Menu
                            theme={"light"}
                            onClick={onClick}
                            mode="horizontal"
                            items={items1}
                            defaultSelectedKeys={['3']}
                            style={{ flex: 1, minWidth: 0, backgroundColor: JutgeColors.colors.color6 }}
                        />
                    )}
                    {isRole3 && (
                        <div style={{ color: '#fff', fontWeight: 'bold', fontSize: '1.2rem', paddingLeft: 8 }}>
                            Jutge Online
                        </div>
                    )}
                </div>

                {!isRole3 && <GlobalChatNotification />}

                {isAdmin && (
                    <div style={{ marginRight: 24, cursor: 'pointer' }} onClick={() => setAdminSugerimentsVisible(true)}>
                        <Badge count={unreadCount} overflowCount={99}>
                            <BsBell style={{ color: 'white', fontSize: 20 }} />
                        </Badge>
                    </div>
                )}

                {isImpersonating && (
                    <Button
                        type="primary"
                        danger
                        onClick={handleStopImpersonation}
                        style={{ marginRight: 16 }}
                    >
                        Volver a Admin
                    </Button>
                )}

                {/* Icono de perfil centralizado */}
                <UserProfileMenu />

                <ChatTableModal
                    visible={historyVisible}
                    onClose={() => setHistoryVisible(false)}
                    isHistory={true}
                    aula={{ id: 0 }}
                />
                <SugerimentsModal visible={sugerimentsVisible} onClose={() => setSugerimentsVisible(false)} />
                <AdminSugerimentsModal
                    visible={adminSugerimentsVisible}
                    onClose={() => setAdminSugerimentsVisible(false)}
                    onRead={() => setUnreadCount(0)}
                />
            </Header>
        );
    } else {
        return null;
    }
};

export default AppHeader;
